<script>
  // TODO: How to support d3 axis-like transitions?
  import * as d3 from "d3";
  // import { getContext } from "svelte";
  import { fade } from "svelte/transition";

  export let dimensions;
  export let dimension = "x"; // support more positions? (right, top etc.)
  export let scale = null;
  export let formatTick = d3.format(","); // should I use d3 scale formatting by default?
  export let numberOfTicks;
  export let drawAxisLine = true;
  export let drawGrid = false;
  export let transform = null;
  // export let tickGap = 80

  // const { dimensions: dimensionsStore } = getContext("Chart");
  // $: dimensions = $dimensionsStore;

  // Define number of ticks
  $: if (numberOfTicks === undefined) {
    numberOfTicks =
      dimension == "x"
        ? dimensions.boundedWidth < 600
          ? dimensions.boundedWidth / 100 // should we allow user to specify tickGap?
          : dimensions.boundedWidth / 250
        : dimensions.boundedHeight / 70;
  }

  $: ticks = scale.ticks(numberOfTicks);
</script>

<g
  in:fade={{ duration: 1000 }}
  class="Axis Axis--dimension-{dimension}"
  transform={transform || `translate(0, 0)`}
>
  <!-- Draw line -->
  {#if drawAxisLine}
    <line
      class="Axis__line"
      x2={dimension == "x" ? dimensions.boundedWidth : 0}
      y2={dimension == "y" ? dimensions.boundedHeight : 0}
    />
  {/if}

  <!-- Draw ticks -->
  {#each ticks as tick}
    <!-- To include tick marks too? -->
    <text
      class="Axis__tick"
      transform={`translate(${(dimension == "x"
        ? [scale(tick), -dimensions.boundedHeight / 2 - 15]
        : [-16, scale(tick)]
      ).join(", ")})`}
    >
      {formatTick(tick)}
    </text>

    <!-- Draw grid -->
    {#if drawGrid}
      <line
        class="Axis__grid"
        transform={`translate(${(dimension == "x"
          ? [scale(tick), -dimensions.boundedHeight / 2]
          : [0, scale(tick)]
        ).join(", ")})`}
        x2={dimension == "x" ? 0 : dimensions.boundedWidth}
        y2={dimension == "y" ? 0 : dimensions.boundedHeight}
      />
    {/if}
  {/each}

  <!-- Draw labels -->
  <text
    class="Axis__x-label"
    style="transform: translate({(dimension == 'x'
      ? [dimensions.boundedWidth, -10]
      : [-56, dimensions.boundedHeight / 2]
    )
      .map((d) => d + 'px')
      .join(', ')}) {dimension == 'y' ? 'rotate(-90deg)' : ''}"
  >
    Older →
  </text>

  <text
    class="Axis__y-label-pos"
    style="transform: translate({(dimension == 'x'
      ? [0, -10]
      : [-56, dimensions.boundedHeight / 2]
    )
      .map((d) => d + 'px')
      .join(', ')}) {dimension == 'y' ? 'rotate(-90deg)' : ''}"
  >
    ↑ Females
  </text>
  <text
    class="Axis__y-label-neg"
    style="transform: translate({(dimension == 'x'
      ? [0, 10]
      : [-56, dimensions.boundedHeight / 2]
    )
      .map((d) => d + 'px')
      .join(', ')}) {dimension == 'y' ? 'rotate(-90deg)' : ''}"
  >
    ↓ Males
  </text>
</g>

<style>
  .Axis__line {
    stroke: var(--dark-grey);
    stroke-opacity: 1;
    stroke-width: 2;
  }

  .Axis__grid {
    /* stroke: #b2a6af; */
    stroke: #b2a6af;
    stroke-opacity: 0.5;
    pointer-events: none;
    stroke-width: 1.5;
  }

  .Axis__x-label {
    text-anchor: end;
    font-size: 0.8em;
    letter-spacing: 0.01em;
  }
  .Axis__y-label-pos {
    text-anchor: start;
    font-size: 0.8em;
    letter-spacing: 0.01em;
    fill: var(--purple);
  }
  .Axis__y-label-neg {
    text-anchor: start;
    dominant-baseline: hanging;
    font-size: 0.8em;
    letter-spacing: 0.01em;
    fill: var(--green);
  }

  .Axis__tick {
    font-size: 0.7em;
    fill: #b2a6af;
    transition: all 0.3s ease-out;
  }

  .Axis--dimension-x .Axis__tick {
    text-anchor: middle;
  }

  .Axis--dimension-y .Axis__tick {
    dominant-baseline: middle;
    text-anchor: end;
  }
</style>
